import {
    Vue, Component, Prop,
} from 'vue-property-decorator';

/**
 * Badge Props
 */
@Component
class Props extends Vue {
    /**
     * Icon
     */
    @Prop() icon!: string;

    /**
     * Size
     * 
     * The accepted values can be changed via the sizes map
     * 
     * @values "xtiny", "tiny", "mini", "xsmall", "small", "normal", "medium", "large", "xlarge"
     */
    @Prop({ default: 'normal' }) iconSize!: string;

    /**
     * Color
     */
    @Prop({ default: 'default' }) iconColor!: string;

    /**
     * Icons library code name. here's a list of supported icons libraries:
     * 'mdi' - Material Design Icons - https://materialdesignicons.com/
     * 'fa' - Font Awesome - https://fontawesome.com/icons
     */
    @Prop({ type: String, default: 'fa' }) iconLibrary!: string;

    /**
     * Prefix of the icon
     * Font Awesome prefix: 'fab', 'far', 'fas'.
     */
    @Prop({ type: String, default: 'fas' }) iconPrefix!: string
}

export default Props;
